var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feCheck0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feCheck1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "feCheck2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00008 2.66667L0.666748 4L4.66675 8L11.3334 1.33333L10.0001 0L4.66675 5.33333L2.00008 2.66667Z",
    fill: "#F5F5F5",
    fillOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.e637f9b463258e3d0b7ba3e88b6dc860.svg";
export { ForwardRef as ReactComponent };